import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import RescheduleModalWrapper from '../../components/HistoryComps/AppointmentComps/RescheduleModalWrapper';
import ShowAllAppointmentHistory from '../../components/HistoryComps/AppointmentComps/ShowAllAppointmentHistory';
import AppointmentHistoryProvider from '../../contexts/AppointmentHistoryProvider';
import RescheduleProvider from '../../contexts/RescheduleProvider';

const Appointment = () => {
  // rendering appointment history page component here
  return (
    <>
      <PageTitle title='Appointment History' />

      <RescheduleProvider>
        <AppointmentHistoryProvider>
          <ShowAllAppointmentHistory />
          <RescheduleModalWrapper />
        </AppointmentHistoryProvider>
      </RescheduleProvider>
    </>
  );
};

export default Appointment;
